"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentWithBoundariesSchema = void 0;
exports.migrateComponentWithBoundaries = migrateComponentWithBoundaries;
const ComponentBoundary_1 = require("../ComponentBoundary");
const ModeBase_1 = require("./ModeBase");
const FunctionalModels_1 = require("../FunctionalModels");
const component_1 = require("./component");
const IComponentFunction_1 = require("../FunctionalModels/IComponentFunction");
exports.ComponentWithBoundariesSchema = component_1.ComponentSchema.extend({
    modes: ModeBase_1.ModeBaseSchema.array(),
    boundaries: ComponentBoundary_1.ComponentBoundarySchema.array(),
    resources: FunctionalModels_1.IComponentResourceSchema.array().optional(),
    functions: IComponentFunction_1.IComponentFunctionSchema.array().optional(),
});
function migrateComponentWithBoundaries(component) {
    const migratedComponent = (0, component_1.migrateComponent)(component);
    return {
        ...migratedComponent,
        entity: { ...migratedComponent.entity, boundaries: component.boundaries, modes: component.modes },
    };
}
//# sourceMappingURL=ComponentWithBoundaries.js.map